import { render } from "./ManageProductInvoice.vue?vue&type=template&id=3d0aed11"
import script from "./ManageProductInvoice.vue?vue&type=script&lang=js"
export * from "./ManageProductInvoice.vue?vue&type=script&lang=js"

import "./ManageProductInvoice.vue?vue&type=style&index=0&id=3d0aed11&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__